import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import getTranslatedText from '../../../helper/get_translated_text';
import { getTranslationElement } from '../../../helper/getTranslationElement';

const getLabel = onClick =>
    getTranslationElement('pdp-sidebar-all-items-price-mates-rates', {}, { onClick });

export const AllItemsPriceMatesRates = props => (
    <Price
        name="all-items-price all-items-price--mates-rates"
        label={getLabel(props.onMatesRatesLearnMoreClick)}
        price={props.price}
        currencyIsoCode={props.currencyIsoCode}
        overrides={{ decimalDigits: 2 }}
    />
);

AllItemsPriceMatesRates.propTypes = {
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
};
